import * as WS from '../webServices/cyMyManager';
type TableClientiProps = {
    cliente: WS.Plus.IF.Cliente;
    passToModal: () => void;
};

export default function TableClienti(props: TableClientiProps):JSX.Element {
    
    return (
        <tr onClick={props.passToModal} >
            <td className='table-cell-mobile'>
                <span className='table-label-mobile' style={{width: 'fit-content'}}>#{props.cliente.Id}</span>
                <span className='table-title-mobile'>{props.cliente.RagioneSociale}</span>
            </td>
        </tr>
    )
}